import { __decorate, __metadata } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import LvIcon from "../icon/LvIcon.vue";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvFilePreview";
/**
 * Display a preview of a file, if the file is a picture.
 * <br>A fallback can be displayed if the file is not a picture.
 */
let LvFilePreview = class LvFilePreview extends UIComponent {
    constructor() {
        super(...arguments);
        this.isImage = false;
    }
    created() {
        this.$loader.begin();
    }
    get fileCardStyle() {
        if (this.isImage) {
            return {
                "background-image": `url('${this.url}')`,
            };
        }
        else
            return {};
    }
    get stateIcon() {
        switch (this.state) {
            case "success":
                return "las la-check";
            case "warning":
                return "las la-exclamation";
            case "danger":
                return "las la-times";
            default:
                return "las la-question";
        }
    }
    onFileLoaded(ev) {
        this.isImage = true;
        this.$loader?.end();
    }
    onFileError(ev) {
        this.isImage = false;
        this.$loader?.end();
    }
};
__decorate([
    Prop({ type: String, required: true }),
    __metadata("design:type", String)
], LvFilePreview.prototype, "url", void 0);
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", Object)
], LvFilePreview.prototype, "state", void 0);
LvFilePreview = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: { LvIcon },
        loader: true,
    })
], LvFilePreview);
export default LvFilePreview;
//# sourceMappingURL=script.js.map